
/* Gera número randomico real
para evitar falha de segurança reportada pelo SonarQube */

export function random() {
    var array = new Uint32Array(1);
    let num = window.crypto.getRandomValues(array);    
    return num[0]/10000000000;
}